import { Badge, BadgeProps } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type Props = {
  status: boolean;
  text?: string;
} & BadgeProps;
const BadgeActiveStatus = ({ className, status, text, ...props }: Props) => {
  if (status === undefined) return <></>;
  return (
    <Badge
      variant={'secondary'}
      className={cn(
        'text-blue-500',
        status && 'bg-success/10 text-success',
        !status && 'bg-muted text-muted-foreground',
        className
      )}
      {...props}
    >
      {text && text + ' · '}
      {status ? 'Active' : 'Inactive'}
    </Badge>
  );
};

export default BadgeActiveStatus;
